






import { Component, Prop, Vue } from 'vue-property-decorator';

import { shortDateToSlashDate } from '@/common/datetime';


@Component
export default class DateLabel extends Vue {
  @Prop() value!: string;

  get dateStr() {
    return shortDateToSlashDate(this.value) || '';
  }
}
